// extracted by mini-css-extract-plugin
export var bounce = "_ny-1";
export var generatingText = "_ny-6";
export var lightning = "_ny-4";
export var popup = "_ny-5";
export var progressBar = "_ny-7";
export var progressFill = "_ny-8";
export var progressShimmer = "_ny-9";
export var progressText = "_ny-a";
export var shimmer = "_ny-3";
export var uploadIcon = "_ny-0";
export var uploadingText = "_ny-2";